/**
 * Resource nghiệp vụ thu thi hành án
 * ndquang1 22.5.2024
 */
export default {
    Title: 'Phân phối thu thi hành án',
    JusticeDecision: 'Số quyết định',
    Date: 'Ngày lập phương án phân phối',
};
